export const API_BASE = (import.meta.env.VITE_COACH_API_URL || 'http://localhost:8000').replace(/\/$/, '')
